import axios from 'axios';
import { useInfiniteQuery } from 'react-query';

import { WarriorsResult } from '~/../api/common.types';
import { useGetCurrentToken } from '~/hooks/auth/useGetCurrentToken';

export const useGetOwnedWarriors = (enabled, address) => {
  // const { data: token } = useGetCurrentToken(address);
  // const { data: token } = useGetCurrentToken(
  //   connectedAccount?.address || ''
  // );
  const { data: token } = useGetCurrentToken({
    address: address!,
    enabled: Boolean(address),
  }
  );
  const apiHost = process.env.NEXT_PUBLIC_API_HOST;
  return useInfiniteQuery<WarriorsResult | undefined, Error>(
    ['warriors', 'owned', token],
    async ({ pageParam = 0 }) => {
      const window = 15;
      const limit = window + pageParam * window;
      const skip = pageParam * window;
      const url = `${apiHost}/warriors/owned${
        pageParam ? `?skip=${skip}&limit=${limit}` : ''
      }`;
      const { data } = await axios({
        url,
        method: 'get',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return {
        warriors: data.warriors,
        hasMore: data.has_more,
        skip: data.skip,
        limit: data.limit,
      };
    },
    {
      enabled: token !== undefined && enabled,
      staleTime: 60 * 1000 * 5,
      // keepPreviousData: true,
      getNextPageParam: (_, pages) => {
        return pages.length;
      },
    }
  );
};
